export default {
  title: 'Trouvez quelque chose que vous aimez !',
  description: "Vos commandes s'afficheront ici.",
  buttons: {
    order_now: 'Commander maintenant',
  },
};
